import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StringUtilsService {

  public getNormalizedName(name: string): string {
    return name
      .toLocaleLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/['"]/g, '');
  }

  //taken from https://gist.github.com/codeguy/6684588?permalink_comment_id=3332719#gistcomment-3332719
  public slugify(text: string): string {
    return text
      .toString()
      .normalize('NFD') // split an accented letter in the base letter and the acent
      .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^\w-]+/g, '')
      .replace(/--+/g, '-')
      .replace(/(^-+)|(-+$)/g, '');
  }

  public getInitial(fullName: string): string {
    const fullNameTrimmed = fullName.trim();
    if (!fullNameTrimmed) {
      return '';
    }
    try {
      return fullNameTrimmed
        .trim()
        .split(' ')
        .filter((c) => !!c.trim())
        .slice(0, 2)
        .map((part) => part[0])
        .join('')
        .toLowerCase();
    } catch (ex) {
      return fullName.slice(0, 2).toLowerCase();
    }
  }

  public containsAnyLetter(input: string): boolean {
    const letterRegex = /[a-zA-Z]/;
    return letterRegex.test(input);
  }
}
